@if(isListView){
    @if (isStreamView) { @if (this.theme === 'split-videoboard') {
        <div class="split-videoboard-container">
          <div class="svb-row">
            <div class="svb-participant">
              @let imgUrlSide1 = drawLogoUrl(1); @if (getTeam(1)?.teamId &&
              imgUrlSide1) {
              <div class="svb-logo" slot="start">
                <img [src]="imgUrlSide1" />
              </div>
              }
              <div>
                {{ getAccronym(1) }}
              </div>
            </div>
        
            <div class="svb-score">
              @if (tie.winningSide === 1) {
              <ion-icon
                class="icon win-checkmark"
                color="light"
                name="checkmark"
              ></ion-icon>
              }
        
              {{ getScore(1) }} - {{ getScore(2) }}
        
              @if (tie.winningSide === 2) {
              <ion-icon
                class="icon win-checkmark"
                color="light"
                name="checkmark"
              ></ion-icon>
              }
            </div>
        
            <div class="svb-participant">
              <div>
                {{ getAccronym(2) }}
              </div>
              @let imgUrlSide2 = drawLogoUrl(2); @if (getTeam(2)?.teamId &&
              imgUrlSide2) {
              <div class="svb-logo" slot="start">
                <img [src]="imgUrlSide2" />
              </div>
              }
            </div>
          </div>
        </div>
        } @else {
        <div class="stream-view-wrapper">
          <span>{{ getTeamName(1) }}</span> vs <span>{{ getTeamName(2) }}</span>
          <div style="height: 40px"></div>
          <ion-grid fixed>
            <ion-row>
              <ion-col size="2" class="ion-text-center">
                <app-team-logo
                  [team]="getTeam(1)"
                  sideNumber="1"
                  [tie]="tie"
                ></app-team-logo>
              </ion-col>
        
              <ion-col class="ion-text-center vertical-center" style="font-size: 60px">
                <ion-icon
                  class="icon win-checkmark"
                  [color]="tie.winningSide === 1 ? 'light' : 'dark'"
                  name="checkmark"
                ></ion-icon>
                {{ tie.score }}
                <ion-icon
                  class="icon win-checkmark"
                  [color]="tie.winningSide === 2 ? 'light' : 'dark'"
                  name="checkmark"
                ></ion-icon>
              </ion-col>
              <ion-col size="2" class="ion-text-center">
                <app-team-logo
                  [team]="getTeam(2)"
                  sideNumber="2"
                  [tie]="tie"
                ></app-team-logo>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        } } @else { @if (type === 'default') {
        <ion-card id="tieCard" class="content-width ion-no-padding ion-no-margin">
          <!-- Tie scorecard header - contains team names and number of viewers -->
          <div
            style="
              display: flex;
              height: 40px;
              align-items: center;
              padding: 0 10px;
              font-size: large;
            "
          >
            <div style="flex: 1">
              @if (tie?.matchStatus !== 'TBP') {
              <div>
                @if (tie?.matchStatus === 'IN_PROGRESS') {
                <ion-badge color="secondary">{{'In progress' | translate}}</ion-badge>
                } @else {
                <ion-badge color="light">{{'Completed' | translate}}</ion-badge>
                }
              </div>
              }
        
              <!-- {{ tie.startDate | date: 'EEEE, MMMM d, y, h:mm a' }} -->
            </div>
            @if (authService.authUserSignal()) { @if (tie) {
            <app-follow-tie
              [_tieId]="tie._id"
              [tieViewers]="tie.viewers"
              (click)="$event.stopPropagation()"
            ></app-follow-tie>
            } }
            <!-- <ion-col size="2" class="ion-text-right ion-no-padding" *ngIf="numberOfViewers > 0">
                            <ion-icon class="icon" name="eye"></ion-icon><span class="text">{{ numberOfViewers }}</span>
                        </ion-col> -->
          </div>
        
          <!-- Contains team avatars, score and start tie button that triggers notification -->
          <ion-card-content (click)="navigateToTieDetails()">
            <ion-card-subtitle>
              @if(isListView) {
              <span>{{ getTeamName(1) }}</span> vs <span>{{ getTeamName(2) }}</span>
              } @else {
              <span
                (click)="navigateToTeam(1)"
                style="text-decoration: underline; cursor: pointer"
                >{{ getTeamName(1) }}</span
              >
              vs
              <span
                (click)="navigateToTeam(2)"
                style="text-decoration: underline; cursor: pointer"
                >{{ getTeamName(2) }}</span
              >
              }
            </ion-card-subtitle>
            {{ tie.startDate | date : "EEEE, MMMM d, y, h:mm a" }}
        
            <ion-grid fixed>
              <ion-row>
                <ion-col size="2" class="ion-text-center">
                  <app-team-logo
                    (click)="navigateToTeam(1)"
                    [team]="getTeam(1)"
                    sideNumber="1"
                    [tie]="tie"
                  ></app-team-logo>
                </ion-col>
        
                <ion-col
                  class="ion-text-center vertical-center"
                  style="font-size: x-large"
                >
                  <ion-icon
                    class="icon win-checkmark"
                    [color]="side1CheckmarkColor"
                    name="checkmark"
                  ></ion-icon>
                  {{ tie.score }}
                  <ion-icon
                    class="icon win-checkmark"
                    [color]="side2CheckmarkColor"
                    name="checkmark"
                  ></ion-icon>
                </ion-col>
                <ion-col size="2" class="ion-text-center ion-justify-content-center">
                  <app-team-logo
                    (click)="navigateToTeam(2)"
                    [team]="getTeam(2)"
                    sideNumber="2"
                    [tie]="tie"
                  ></app-team-logo>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-content>
        
          <app-tie-bar
            *ngIf="
              !isListView &&
              (isOfficial ||
                isOwner ||
                isTracker ||
                isTeamOwnerSide1 ||
                isTeamOwnerSide2)
            "
            (openMenu)="openMenu.emit()"
            [tie]="tie"
          ></app-tie-bar>
        
          @if (displayDownloadTie() && tie?.organisations?.length) {
          <app-download-tie
            [_tieId]="tie._id"
            [leagueId]="league?._id"
            [tieId]="tie.tieId"
            [templateSubtype]="tie.templateSubtype"
            [partner]="tie?.organisations[0]?.organisationAbbreviation"
          ></app-download-tie>
          }
          <!-- You must be a team owner to be able to download a match -->
          <!-- isOwner is passed from the parent component [team-schedule] -->
        </ion-card>
        <div style="height: 5px" class="content-width"></div>
        } @else if (type==='side-menu') {
        <ion-item style="max-height: 56px" lines="none">
          <ion-label class="ion-text-wrap"
            >{{ getTeamName(1) }} {{'vs' | translate}} {{ getTeamName(2) }}</ion-label
          >
          <ion-text slot="end" style="max-height: 56px">
            <h1 class="ion-no-margin">{{ tie.score }}</h1>
          </ion-text>
        </ion-item>
        } @else if (type==='draw') {
        <ion-card id="tieCard" class="ion-no-padding ion-no-margin">
          <!-- Tie scorecard header - contains team names and number of viewers -->
          <div
            style="
              display: flex;
              height: 40px;
              align-items: center;
              padding: 0 10px;
              font-size: large;
            "
          >
            <div style="flex: 1">
              @if (tie?.matchStatus !== 'TBP') {
              <div>
                @if (tie?.matchStatus === 'IN_PROGRESS') {
                <ion-badge color="secondary">{{'In progress' | translate}}</ion-badge>
                } @else {
                <ion-badge color="light">{{'Completed' | translate}}</ion-badge>
                }
              </div>
              } @else {
              <span class="draw-date">{{
                tie.startDate | date : "EEE MMM d h:mm a"
              }}</span>
              }
            </div>
            @if (authService.authUserSignal() && tie.organisations?.length) { @if (tie)
            {
            <app-follow-tie
              [_tieId]="tie._id"
              [tieViewers]="tie.viewers"
            ></app-follow-tie>
            } }
          </div>
        
          <!-- Contains team avatars, score and start tie button that triggers notification -->
          <ion-card-content (click)="navigateToTieDetails()">
            <div style="display: flex; align-items: center">
              <div style="flex: 1">
                <ion-item lines="none">
                  @if (getTeam(1)?.teamId) {
                  <ion-avatar slot="start">
                    <img [src]="drawLogoUrl(1)" />
                  </ion-avatar>
                  }
                  <ion-label>{{ getAccronym(1) }}</ion-label>
                </ion-item>
              </div>
              <div>
                @if (tie.winningSide === 1) {
                <ion-icon
                  class="icon win-checkmark"
                  color="dark"
                  name="checkmark"
                ></ion-icon>
                }
                {{ getScore(1) }}
              </div>
            </div>
        
            <div style="display: flex; align-items: center; height: 56px">
              <div style="flex: 1">
                <ion-item lines="none">
                  @if (getTeam(2)?.teamId) {
                  <ion-avatar slot="start">
                    <img [src]="drawLogoUrl(2)" />
                  </ion-avatar>
                  }
                  <ion-label>{{ getAccronym(2) }}</ion-label>
                </ion-item>
              </div>
              <div>
                @if (tie.winningSide === 2) {
                <ion-icon
                  class="icon win-checkmark"
                  [color]="side2CheckmarkColor"
                  name="checkmark"
                ></ion-icon>
                }
                {{ getScore(2) }}
              </div>
            </div>
          </ion-card-content>
        </ion-card>
        } @else if (type==='team-match') {
          <ion-card style="margin-left: 16px; margin-right: 16px;" class="tie-card">
            <!-- Header with date/time -->
            <div class="tie-header">
              {{ tie.startDate | date: "EEE, MMM d | h:mm a" }} ET
            </div>
          
            <!-- Main content with logos and team names -->
            <ion-card-content (click)="navigateToTieDetails()" class="tie-content">
              <ion-grid>
                <ion-row class="ion-align-items-center ion-justify-content-center">
                  
                  <!-- Team 1 -->
                  <ion-col size="5" class="ion-text-center">
                    <app-team-logo
                      [team]="getTeam(1)"
                      sideNumber="1"
                      [tie]="tie"
                    ></app-team-logo>
                    <div class="team-name">{{ getTeamName(1) }}</div>
                    <div class="team-gender">(W)</div>
                  </ion-col>
          
                  <!-- VS / @ marker -->
                  <ion-col size="2" class="ion-text-center">
                    <div class="vs-marker">&#64;</div>
                  </ion-col>
                  
                  <!-- Team 2 -->
                  <ion-col size="5" class="ion-text-center">
                    <app-team-logo
                      [team]="getTeam(2)"
                      sideNumber="2"
                      [tie]="tie"
                    ></app-team-logo>
                    <div class="team-name">{{ getTeamName(2) }}</div>
                    <div class="team-gender">(W)</div>
                  </ion-col>
          
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        } }
        
} @else {
    <div class="tie-details-page">
    @if (isStreamView) { @if (this.theme === 'split-videoboard') {
    <div class="split-videoboard-container">
      <div class="svb-row">
        <div class="svb-participant">
          @let imgUrlSide1 = drawLogoUrl(1); @if (getTeam(1)?.teamId &&
          imgUrlSide1) {
          <div class="svb-logo" slot="start">
            <img [src]="imgUrlSide1" />
          </div>
          }
          <div>
            {{ getAccronym(1) }}
          </div>
        </div>

        <div class="svb-score">
          @if (tie.winningSide === 1) {
          <ion-icon
            class="icon win-checkmark"
            color="light"
            name="checkmark"
          ></ion-icon>
          }

          {{ getScore(1) }} - {{ getScore(2) }}

          @if (tie.winningSide === 2) {
          <ion-icon
            class="icon win-checkmark"
            color="light"
            name="checkmark"
          ></ion-icon>
          }
        </div>

        <div class="svb-participant">
          <div>
            {{ getAccronym(2) }}
          </div>
          @let imgUrlSide2 = drawLogoUrl(2); @if (getTeam(2)?.teamId &&
          imgUrlSide2) {
          <div class="svb-logo" slot="start">
            <img [src]="imgUrlSide2" />
          </div>
          }
        </div>
      </div>
    </div>
    } @else {
    <div class="stream-view-wrapper">
      <span>{{ getTeamName(1) }}</span> vs <span>{{ getTeamName(2) }}</span>
      <div style="height: 40px"></div>
      <ion-grid fixed>
        <ion-row>
          <ion-col size="2" class="ion-text-center">
            <app-team-logo
              [team]="getTeam(1)"
              sideNumber="1"
              [tie]="tie"
            ></app-team-logo>
          </ion-col>

          <ion-col class="ion-text-center vertical-center" style="font-size: 60px">
            <ion-icon
              class="icon win-checkmark"
              [color]="tie.winningSide === 1 ? 'light' : 'dark'"
              name="checkmark"
            ></ion-icon>
            {{ tie.score }}
            <ion-icon
              class="icon win-checkmark"
              [color]="tie.winningSide === 2 ? 'light' : 'dark'"
              name="checkmark"
            ></ion-icon>
          </ion-col>
          <ion-col size="2" class="ion-text-center">
            <app-team-logo
              [team]="getTeam(2)"
              sideNumber="2"
              [tie]="tie"
            ></app-team-logo>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    } } @else { @if (type === 'default') {
    <ion-card id="tieCard" class="content-width ion-no-padding ion-no-margin">     
      <ion-card-content (click)="navigateToTieDetails()">
        <ion-grid fixed>
          <ion-row>
            <ion-col size="6" class="ion-text-center {{themeService.isDarkMode ? 'dark': 'light'}}  {{tie.winningSide === 1 && tie?.matchStatus === 'COMPLETED' ? 'win': ''}}">
                <div class="team-logo-container">
                    @if (authService.authUserSignal()) { 
                        @if (tie) {
                        <ion-buttons slot="end" class="follow-tie">
                        <app-follow-team 
                                [_teamId]="getTeam(1)?._id"
                                [teamViewers]="getTeam(1)?.viewers"
                                [tieId]="tie?._id">                                
                            </app-follow-team>
                        </ion-buttons>
                        }
                    }
                    @if(tie.winningSide === 1 && tie?.matchStatus === "COMPLETED"){
                        <ion-icon
                        class="icon win-checkmark"
                        [color]="'dark'"
                        name="checkmark"
                      ></ion-icon>
                    }
                    
                    <app-team-logo
                        (click)="navigateToTeam(1)"
                        [team]="getTeam(1)"
                        sideNumber="1"
                        [tie]="tie"
                    ></app-team-logo>
                </div>

                <ion-card-subtitle class="{{themeService.isDarkMode ? 'dark': 'light'}}">
                    @if(isListView) {
                    <span>{{ getTeamName(1) }}</span>
                    } @else {
                    <span
                      (click)="navigateToTeam(1)"
                      style="cursor: pointer"
                      >{{ getTeamName(1) }}</span
                    >
                    }
                </ion-card-subtitle>
            </ion-col>
            <ion-col size="6" class="ion-text-center {{themeService.isDarkMode ? 'dark': 'light'}}  {{tie.winningSide === 2 && tie?.matchStatus === 'COMPLETED' ? 'win': ''}}">
                <div class="team-logo-container side-2">
                    @if (authService.authUserSignal()) { 
                        @if (tie) {
                        <ion-buttons slot="end" class="follow-tie">
                        <app-follow-team 
                                [_teamId]="getTeam(2)?._id"
                                [teamViewers]="getTeam(2)?.viewers"
                                [tieId]="tie?._id">
                            </app-follow-team>
                        </ion-buttons>
                        }
                    }
                    @if(tie.winningSide === 2 && tie?.matchStatus === "COMPLETED"){
                        <ion-icon
                        class="icon win-checkmark"
                        [color]="'dark'"
                        name="checkmark"
                      ></ion-icon>
                    }
                    <app-team-logo
                        (click)="navigateToTeam(2)"
                        [team]="getTeam(2)"
                        sideNumber="2"
                        [tie]="tie"
                    ></app-team-logo>
                </div>
              
              <ion-card-subtitle class="{{themeService.isDarkMode ? 'dark': 'light'}}">
                @if(isListView) {
                <span>{{ getTeamName(2) }}</span>
                } @else {
                <span
                  (click)="navigateToTeam(2)"
                  style="cursor: pointer"
                  >{{ getTeamName(2) }}</span
                >
                }
              </ion-card-subtitle>
            </ion-col>
            <span class="vs {{themeService.isDarkMode ? 'dark': 'light'}}">VS</span>
          </ion-row>
        </ion-grid>
      </ion-card-content>

      <app-tie-bar
        *ngIf="
          !isListView &&
          (isOfficial ||
            isOwner ||
            isTracker ||
            isTeamOwnerSide1 ||
            isTeamOwnerSide2)
        "
        (openMenu)="openMenu.emit()"
        [tie]="tie"
      ></app-tie-bar>

      @if (displayDownloadTie() && tie?.organisations?.length) {
      <app-download-tie
        [_tieId]="tie._id"
        [leagueId]="league?._id"
        [tieId]="tie.tieId"
        [templateSubtype]="tie.templateSubtype"
        [partner]="tie?.organisations[0]?.organisationAbbreviation"
      ></app-download-tie>
      }
      <!-- You must be a team owner to be able to download a match -->
      <!-- isOwner is passed from the parent component [team-schedule] -->
    </ion-card>
    <div style="height: 5px" class="content-width"></div>
    } @else if (type==='side-menu') {
    <ion-item style="max-height: 56px" lines="none">
      <ion-label class="ion-text-wrap"
        >{{ getTeamName(1) }} vs {{ getTeamName(2) }}</ion-label
      >
      <ion-text slot="end" style="max-height: 56px">
        <h1 class="ion-no-margin">{{ tie.score }}</h1>
      </ion-text>
    </ion-item>
    } @else if (type==='draw') {
    <ion-card id="tieCard" class="ion-no-padding ion-no-margin">
      <!-- Tie scorecard header - contains team names and number of viewers -->
      <div
        style="
          display: flex;
          height: 40px;
          align-items: center;
          padding: 0 10px;
          font-size: large;
        "
      >
        <div style="flex: 1">
          @if (tie?.matchStatus !== 'TBP') {
          <div>
            @if (tie?.matchStatus === 'IN_PROGRESS') {
            <ion-badge color="secondary">{{'In progress' | translate}}</ion-badge>
            } @else {
            <ion-badge color="light">{{'Completed' | translate}}</ion-badge>
            }
          </div>
          } @else {
          <span class="draw-date">{{
            tie.startDate | date : "EEE MMM d h:mm a"
          }}</span>
          }
        </div>
        @if (authService.authUserSignal() && tie.organisations?.length) { @if (tie)
        {
        <app-follow-tie
          [_tieId]="tie._id"
          [tieViewers]="tie.viewers"
        ></app-follow-tie>
        } }
      </div>

      <!-- Contains team avatars, score and start tie button that triggers notification -->
      <ion-card-content (click)="navigateToTieDetails()">
        <div style="display: flex; align-items: center">
          <div style="flex: 1">
            <ion-item lines="none">
              @if (getTeam(1)?.teamId) {
              <ion-avatar slot="start">
                <img [src]="drawLogoUrl(1)" />
              </ion-avatar>
              }
              <ion-label>{{ getAccronym(1) }}</ion-label>
            </ion-item>
          </div>
          <div>
            @if (tie.winningSide === 1) {
            <ion-icon
              class="icon win-checkmark"
              color="dark"
              name="checkmark"
            ></ion-icon>
            }
            {{ getScore(1) }}
          </div>
        </div>

        <div style="display: flex; align-items: center; height: 56px">
          <div style="flex: 1">
            <ion-item lines="none">
              @if (getTeam(2)?.teamId) {
              <ion-avatar slot="start">
                <img [src]="drawLogoUrl(2)" />
              </ion-avatar>
              }
              <ion-label>{{ getAccronym(2) }}</ion-label>
            </ion-item>
          </div>
          <div>
            @if (tie.winningSide === 2) {
            <ion-icon
              class="icon win-checkmark"
              [color]="side2CheckmarkColor"
              name="checkmark"
            ></ion-icon>
            }
            {{ getScore(2) }}
          </div>
        </div>
      </ion-card-content>
    </ion-card>
    } }
</div>
}